<template>
  <div class="row">
    <div class="col-12 d-flex">
      <div class="btn-group">
        <button
          class="d-md-none btn btn-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
           data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ 'Add new block' | translate }}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            href="#"
            v-for="blockType in blockTypesFiltered"
            :key="blockType.type"
            class="dropdown-item"
            @click.prevent="addBlock(blockType.type)"
          >
            {{ blockType.name | translate }}
          </a>
        </div>
      </div>
      <a
        class="btn btn-outline-primary ms-auto"
        :href="preview()"
        target="_blank"
      >
        {{ 'Preview' | translate }}
      </a>
      <div class="dropdown dropleft ms-3" v-if="parent === 'course'">
        <button
          class="btn btn-outline-primary"
          type="button"
          id="dropdownMenuButton"
           data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-ellipsis-v"></i>
        </button>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" :href="`/home/courses/${courseId}`">
            {{ 'Edit' | translate }}
          </a>
          <a class="dropdown-item" :href="`/home/courses/${courseId}/sections`">
            {{ 'Lectures list' | translate }}
          </a>
          <a class="dropdown-item" :href="`/home/courses/${courseId}/leads`">
            {{ 'Leads' | translate }}
          </a>
          <a class="dropdown-item" :href="`/home/courses/${courseId}/stats`">
            {{ 'Engagement' | translate }}
          </a>
        </div>
      </div>
    </div>

    <div class="d-none d-md-block col-3">
      <div class="list-group sticky-top my-3">
        <div style="overflow-y: auto; height: calc(100vh - 4rem);">
          <draggable
            :group="{
              name: 'blocks',
              pull: 'clone',
              put: false,
            }"
            :list="blockTypesFiltered"
            :sort="false"
            :clone="handleBlockAdd"
          >
            <div
              class="list-group-item list-group-item-action text-uppercase grabbable"
              v-for="item in blockTypesFiltered"
              :key="item.type"
              style="user-select: none;"
            >
              {{ item.name | translate }}
            </div>
          </draggable>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-9">
      <div
        v-if="!subpage.blocks.length"
        class="text-center my-3 d-none d-md-block"
      >
        <a href="#" data-bs-toggle="modal" data-bs-target="#showHow">
          {{ 'Drag and drop elements here' | translate }}
        </a>
        <br />
        <i class="fas fa-arrow-down"></i>
        <div
          class="modal fade"
          id="showHow"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  
                </button>
              </div>
              <div class="modal-body">
                <img
                  src="https://djceg34j53tq.cloudfront.net/public/gif-na-strone-sprzedazowa.gif"
                  alt
                  class="img-fluid"
                />
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <draggable
        :list="subpage.blocks"
        @change="initiateUpdateBlocksOrder"
        handle=".grabbable"
        group="blocks"
      >
        <Block
          v-for="block in subpage.blocks"
          :key="block.id"
          :block-data="block"
          @remove="removeBlock"
          @blockUpdate="updateBlock"
          @blockDuplicated="blockDuplicated"
        ></Block>
      </draggable>
    </div>

    <div class="col-12 mb-3 d-md-none" v-if="subpage.blocks.length > 1">
      <div class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
           data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ 'Add new block' | translate }}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            href="#"
            v-for="blockType in blockTypesFiltered"
            :key="blockType.type"
            class="dropdown-item"
            @click.prevent="addBlock(blockType.type)"
          >
            {{ blockType.name | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
import route from './../routes.js'
import Block from './blocks/Block'

export default {
  components: {
    draggable,
    Block,
  },
  props: ['subpageData'],
  data() {
    return {
      blockTypes: [
        { type: 'banner', name: 'Banner' },
        { type: 'bio', name: 'Bio' },
        { type: 'button', name: 'Button' },
        { type: 'lecture-list', name: 'Lecture list' },
        { type: 'course-list', name: 'Product list' },
        { type: 'html', name: 'HTML' },
        { type: 'text', name: 'Text' },
        { type: 'quote', name: 'Quote' },
        { type: 'checklist', name: 'Checklist' },
        { type: 'side-image', name: 'Side image' },
        { type: 'gallery', name: 'Gallery' },
        { type: 'columns', name: 'Columns' },
        { type: 'image', name: 'Image' },
        { type: 'faq', name: 'FAQ' },
        { type: 'lead-generation', name: 'Lead generation' },
        { type: 'video', name: 'Video' },
        { type: 'video-embed', name: 'Video embed' },
        { type: 'countdown-time', name: 'Countdown (time)' },
      ],
      subpage: this.subpageData,
      parent: this.subpageData.course_id ? 'course' : 'page',
    }
  },
  mounted() {},
  computed: {
    courseId() {
      return this.subpageData.course_id
    },
    blockTypesFiltered() {
      return this.blockTypes.filter((i) => {
        if (this.parent === 'page') {
          return !_.includes(
            ['lecture-list', 'button', 'lead-generation'],
            i.type,
          )
        }
        if (
          this.parent === 'course' &&
          _.includes(['bundle', 'consultation'], this.subpage.course.type)
        ) {
          return !_.includes(['course-list', 'lecture-list'], i.type)
        }
        if (
          this.parent === 'course' &&
          _.includes(['course'], this.subpage.course.type)
        ) {
          return !_.includes(['course-list'], i.type)
        }

        return true
      })
    },
  },
  methods: {
    blockDuplicated(block) {
      this.storeBlock({
        ...block,
        sort_order:
          parseInt(
            _.maxBy(this.subpage.blocks, (block) => {
              return block.sort_order
            }),
          ) + 1,
      })
    },
    updateBlock(data) {
      let i = _.findIndex(this.subpage.blocks, (block) => {
        return block.id === data.id
      })

      this.$set(this.subpage.blocks, i, data)
    },
    handleBlockAdd({ type }) {
      switch (type) {
        case 'text':
          return {
            type,
            quill:
              '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
            html: '<h2>Sample Header</h2><p>Sample Text</p>',
          }
          break

        case 'banner':
          return {
            type,
            overlay: '#FF5D007D',
            quill:
              '{"ops":[{"attributes":{"color":"#ffffff"},"insert":"Sample Header"},{"attributes":{"align":"center","header":2},"insert":"\\n"},{"attributes":{"color":"#ffffff"},"insert":"Sample Text"},{"attributes":{"align":"center"},"insert":"\\n"}]}',
            html:
              '<h2 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Sample Header</span></h2><p class="ql-align-center"><span style="color: rgb(255, 255, 255);">Sample Text</span></p>',
          }
          break

        case 'countdown-time':
          let today = new Date()
          let tommorow = new Date()
          tommorow.setDate(today.getDate() + 1)
          return {
            type,
            settings: {
              end_date: tommorow,
            },
          }
          break

        case 'side-image':
          return {
            type,
            overlay: null,
            quill: '{"ops":[{"insert":"\\n"}]}',
            html: '<p><br></p>',
          }
          break

        default:
          return {
            type,
          }
          break
      }
    },
    preview() {
      if (this.parent === 'page') {
        return '/account/page/preview'
      }
      return `/home/subpages/${this.subpage.id}/preview`
    },

    removeBlock(block) {
      this.$set(
        this.subpage,
        'blocks',
        _.reject(this.subpage.blocks, (b) => b.id === block.id),
      )
      iziToast.success({
            title: 'OK',
            message: this.$t('Deleted'),
            position: 'bottomLeft',
          })
    },

    addBlock(type) {
      switch (type) {
        case 'text':
          this.storeBlock({
            type,
            quill:
              '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
            html: '<h2>Sample Header</h2><p>Sample Text</p>',
          })
          break

        case 'banner':
          this.storeBlock({
            type,
            overlay: '#FF5D007D',
            quill:
              '{"ops":[{"attributes":{"color":"#ffffff"},"insert":"Sample Header"},{"attributes":{"align":"center","header":2},"insert":"\\n"},{"attributes":{"color":"#ffffff"},"insert":"Sample Text"},{"attributes":{"align":"center"},"insert":"\\n"}]}',
            html:
              '<h2 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Sample Header</span></h2><p class="ql-align-center"><span style="color: rgb(255, 255, 255);">Sample Text</span></p>',
          })
          break

        case 'countdown-time':
          let today = new Date()
          let tommorow = new Date()
          tommorow.setDate(today.getDate() + 1)
          this.storeBlock({
            type,
            settings: {
              end_date: tommorow,
            },
          })
          break

        case 'side-image':
          this.storeBlock({
            type,
            overlay: null,
            quill: '{"ops":[{"insert":"\\n"}]}',
            html: '<p><br></p>',
          })
          break

        default:
          this.storeBlock({
            type,
          })
          break
      }
    },

    handleError(error) {
      if (error.response && error.response.status === 419) {
        this.$root.$emit(
          'flash',
          this.$t('Your session has expired - please reload'),
          'warning',
        )
      } else {
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
        console.error(error)
      }
    },

    storeBlock(newBlock) {
      axios
        .post(route.block(this.subpage).store, newBlock)
        .then((response) => {
          let block = response.data
          this.subpage.blocks.push(block)
        })
        .then(() => {
          iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
        })
        .catch(this.handleError)
    },

    storeAndUpdate(block) {
      return axios.post(route.block(this.subpage).store, block)
    },

    newOrder() {
      this.subpage.blocks = this.subpage.blocks.map((b, i) => {
        return {
          ...b,
          sort_order: i,
        }
      })
    },

    handleValidationError(blocks) {
      iziToast.error({
        title: 'Error',
        message: this.$t('Something went wrong'),
        position: 'bottomLeft',
      })

      this.subpage.blocks = blocks
    },

    initiateUpdateBlocksOrder(e) {
      if (e.added) {
        this.newOrder()

        this.storeAndUpdate(e.added.element)
          .then((response) => response.data)
          .then((block) => {
            this.$set(this.subpage.blocks, e.added.newIndex, block)
          })
          .then(() => {
            return this.updateBlockOrder()
          })
          .then((response) => {
            if (
              _.has(response.data, 'errors') &&
              _.has(response.data, 'blocks')
            ) {
              this.handleValidationError(response.data.blocks)
            } else {
              iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
            }
          })
          .catch(this.handleError)
      }
      if (e.moved) {
        this.updateBlockOrder()
          .then((response) => {
            if (
              _.has(response.data, 'errors') &&
              _.has(response.data, 'blocks')
            ) {
              this.handleValidationError(response.data.blocks)
            } else {
              iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
            }
          })
          .catch(this.handleError)
      }
    },

    updateBlockOrder() {
      this.newOrder()

      return axios.patch(
        route.block(this.subpage).order,
        _.sortBy(this.subpage.blocks, 'id'),
      )
    },
  },
}
</script>

<style>
.ql-expanded {
  z-index: 2 !important;
}
</style>
